"use client";
import { motion } from "framer-motion";
import { scrollSectionProps } from "@lib/motion";
import './scrollSection.css';

interface ScrollSectionProps {
  children: React.ReactNode;
  className?: string;
  skipAnimation?: boolean;
}

export const ScrollSection = ({ children, className = "", skipAnimation = false }: ScrollSectionProps) => {
  const baseClasses = `scroll-section ${className}`;

  if (skipAnimation) {
    return <section id="scroll-section" className={baseClasses}>{children}</section>;
  }

  return (
    <motion.section id="scroll-section" {...scrollSectionProps} className={baseClasses}>
      {children}
    </motion.section>
  );
};